<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Confirm bulk claim status change" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .text-neutral-700
          .yz-medium-body-md.mb-2 Are you sure you want to change the status for all selected claims?
          .yz-regular-body-sm.mb-4
            | Notes added will appear in the log.

          // Status comparison section
          yz-card.pa-3(outlined, color="yz-neutral-200")
            // Current status
            v-row(no-gutters)
              v-col(cols="5")
                .yz-medium-body-sm.text-neutral-500 Current status
              v-col(cols="7")
                .yz-medium-body-sm(:class="currentStatusColor") {{ currentStatusLabel }}

            // New status
            v-row.mt-3(no-gutters)
              v-col(cols="5")
                .yz-medium-body-sm.text-neutral-500 New status
              v-col(cols="7")
                .yz-medium-body-sm(:class="newStatusColor") {{ newStatusLabel }}

          // Warning message for received status
          .mt-4(v-if="newStatus === 'received'")
            yz-card.pa-3(outlined, color="yz-warning-100", border-color="yz-warning-500")
              .d-flex.gap-2
                yz-icon(color="yz-warning-500" size="20") $yzi-alert-circle
                .yz-regular-body-sm.text-neutral-700
                  | Once
                  span.font-semibold.ml-1 status
                  |  is changed to
                  span.font-semibold.ml-1 Received
                  | , you will not be able to change the
                  span.font-semibold.ml-1 claim status
                  |  or
                  span.font-semibold.ml-1 amount
                  | . However, you can still upload new files or edit remarks.

          // Note field
          .mt-6
            .yz-medium-body-sm.text-neutral-700.mb-2 Note (optional)
            yz-textarea(v-model="remarks" placeholder="Enter note here" rows="4" background-color="white" width="full")

      yz-dialog-normal-actions(save-label="Confirm" cancel-label="Cancel" :loading="isLoading" @save="onConfirm" @cancel="onCancel")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    currentStatus: {
      type: String,
      default: ''
    },
    newStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      remarks: null,
      isLoading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    currentStatusLabel() {
      const statusMap = {
        submitted: 'Submitted',
        approved: 'Approved',
        rejected: 'Rejected',
        received: 'Received'
      }
      return statusMap[this.currentStatus] || this.currentStatus
    },
    newStatusLabel() {
      const statusMap = {
        submitted: 'Submitted',
        approved: 'Approved',
        rejected: 'Rejected',
        received: 'Received'
      }
      return statusMap[this.newStatus] || this.newStatus
    },
    currentStatusColor() {
      const colorMap = {
        submitted: 'text-warning-500',
        approved: 'text-success-500',
        rejected: 'text-danger-500',
        received: 'text-success-500'
      }
      return colorMap[this.currentStatus] || 'text-neutral-700'
    },
    newStatusColor() {
      const colorMap = {
        submitted: 'text-warning-500',
        approved: 'text-success-500',
        rejected: 'text-danger-500',
        received: 'text-success-500'
      }
      return colorMap[this.newStatus] || 'text-neutral-700'
    }
  },
  methods: {
    onConfirm() {
      this.isLoading = true
      this.$emit('confirmed', this.remarks)
    },
    onCancel() {
      this.$emit('canceled')
      this.onClose()
    },
    onClose() {
      this.showDialog = false
    }
  }
}
</script>

<style scoped></style>
